import { createTracker } from 'usage-tracker';
import events from 'automation-ui-canvas/events.yaml';
import { trackEvent as coreTrackEvent, trackPageView as coreTrackPageView, trackedEventPartial as coreTrackEventPartial } from 'automation-ui-usage-tracking/trackingUtils';
import { enhanceTrackerWithFullstory } from 'data-ops-fullstory';
// NOTE(bheng): This file should only be referenced by Workflows Classic.

export const usageTracker = enhanceTrackerWithFullstory(createTracker({
  events,
  properties: {
    namespace: 'workflows'
  },
  lastKnownEventProperties: ['screen'],
  debug: false
}));
export const immediateUsageTracker = usageTracker.clone({});
export const trackPageView = (screen, extraJson = {
  userReadOnly: false
}) => {
  coreTrackPageView(usageTracker, {
    screen
  }, extraJson);
};
export const trackEvent = (trackableKey, extraJSON = {}, immediate = false) => {
  coreTrackEvent(immediate ? immediateUsageTracker : usageTracker, trackableKey, extraJSON);
};
export const trackedEventPartial = (trackableKey, extraJSON = {}, immediate = false) => {
  coreTrackEventPartial(immediate ? immediateUsageTracker : usageTracker, trackableKey, extraJSON);
};